<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("nova-linha-produto") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="voltar"
                >
                    {{ $t("voltar") }}
                </button>
                <button class="save-btn" type="button" @click="saveLinhaPergunta">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input 
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="lp.idlinhaprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!lp.idlinhaprodutoerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                v-model="lp.descricao"
                                :id="generateId(2)"
                                placeholder="descricao-da-linha-placeholder"
                                :maxlength="50"
                                title="descricao-da-linha-produto"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!lp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(3)"
                                ref="gpSelect"
                                title="sub-grupo-linha-produto"
                                v-model="subgrupo"
                                :placeholder="'grupo-do-sub-grupo-placeholder'"
                                required
                                disabled
                                tooltipLabel="info-subgrupo-linhaproduto"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LinhaProdutoService from "@/services/LinhaProdutoService";
import GrupoProdutoService from "@/services/GrupoProdutoService";
import LinhaValidation from "@/services/validations/LinhaValidation";
import Message from "@/models/Message";

export default {
    props: {
        grupo: {},
        subgrupo: {}
    },
    data() {
        return {
            service: null,
            gruposervice: null,
            validation: null,
            isSaving: false,
            lp: {
                situacao: 1,
                subgrupoproduto: null,
                nomeunico: null,
            },
            msgs: [],
        };
    },
    created() {
        this.service = new LinhaProdutoService(this.$http, this.$router);
        this.gruposervice = new GrupoProdutoService(this.$http, this.$router);
        this.validation = new LinhaValidation(this.msgs);
    },

    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        voltar() {
            this.$emit("voltar")
        },
        saveLinhaPergunta() {
            this.isSaving = true;
            this.lp.subgrupoproduto = { idsubgrupoproduto: this.subgrupo.id };
            this.lp.grupoproduto = { idgrupoproduto: this.grupo.id };
            this.lp = this.mapTosave(this.lp);
            if (this.validation.validate(this.lp, this.$refs)) {
                this.service
                    .save(this.lp)
                    .then((body) => {
                        if (body.content) {
                            let msg = "msg-linha-salva";
                            if (this.lp.id) {
                                msg = "msg-linha-editada";
                            }
                            this.lp = body.content;
                            this.msgs.push(
                                new Message("success", msg, true)
                            );

                            let objEmit = {
                                'origem': 'linha',
                                'obj': { id: this.lp.id, label: this.lp.descricao } 
                            };

                            setTimeout(() => {
                                this.$emit('sucesso', objEmit);
                            }, 1000);
                        } else {
                            this.isSaving = false;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.lp.idlinhaprodutoerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(
                            new Message(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            )
                        );
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    background-color: $sovis-white;
}
</style>
